module.exports = __webpack_public_path__ + "assets/img/line-3-1.5b2691e4.png";